import styled, { css } from 'styled-components';
import {
  ItemContainer,
  ItemCount,
  ItemDetails,
  ItemName,
  ItemArea,
} from 'src/components/MeasureSidebar/MeasureExtendedSidebar/styled';

export const Container = styled(ItemContainer)`
  ${({ theme }) => css`
    padding: ${theme.utils.pxToRem(10)}rem ${theme.utils.pxToRem(20)}rem;
    height: ${theme.utils.pxToRem(60)}rem;
  `}
`;

export const ThumbnailWithCount = styled.div`
  ${({ theme, src }) => css`
    height: ${theme.utils.pxToRem(38)}rem;
    width: ${theme.utils.pxToRem(38)}rem;
    border-radius: ${theme.utils.pxToRem(2)}rem;
    border-width: ${theme.utils.pxToRem(1)}rem;
    border-bottom-style: solid;
    border-color: ${theme.colors.viewer.sidebar.categoryBorder};
    background: url(${src}) no-repeat center center;
    background-color: ${theme.colors.viewer.sidebar.countBox};
    background-size: 140%;
    overflow: hidden;
  `}
`;

export const CountOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ theme }) => css`
    height: ${theme.utils.pxToRem(22)}rem;
    background-color: ${theme.colors.viewer.sidebar.thumbnailOverlay};
  `}
`;

export const Count = styled(ItemCount)``;
export const Details = styled(ItemDetails)``;
export const Name = styled(ItemName)``;
export const Area = styled(ItemArea)``;
